/**
 * 常量
 * 
*/


//左测设备树
export const ORG_DEVICE_DATA = 'home/ORG_DEVICE_DATA';
// 设备树点击数据- 状态数据
export const ORG_BREAD_CRUMBS = 'home/ORG_BREAD_CRUMBS';
// 设备树点击数据- 缓存数据key
export const ORG_BREAD_CRUMBS_CATCH = 'home/ORG_BREAD_CRUMBS_CATCH';
// 采集点类型列表数据
export const PATCH_TYPE_DATAS = 'home/PATCH_TYPE_DATAS';

